import { connect } from 'react-redux'

import { receiveAccounts } from 'modules/accounts/actions'
import { showTransientNotification, receiveUserSettings } from '@driftt/traffic-control'

import AccountsHome from 'pages/AccountsHome'

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    users: state.org.users,
    settings: state.user.settings,
    currentUserId: state.user.id,
    bootstrapComplete: state.config.bootstrapComplete,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReceiveUserSettings: settings => {
      dispatch(receiveUserSettings(settings))
    },

    onReceiveAccounts: accounts => {
      dispatch(receiveAccounts(accounts))
    },

    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountsHome)
